import React from 'react';
import classNames from 'classnames';
import { elementType, number, string, bool } from 'prop-types';

import { IconHeartFilled } from '../IconHeart/IconHeartFilled';
import { IconHeartOutlined } from '../IconHeart/IconHeartOutlined';

import css from './WishlistButton.module.css';

const WishlistButton = ({
  className,
  checked,
  count,
  checkedTitle,
  uncheckedTitle,
  checkedComponent: Checked,
  uncheckedComponent: Unchecked,
  ...props
}) => (
  <button
    className={classNames(css.wishlistButton, className)}
    title={checked ? checkedTitle : uncheckedTitle}
    {...props}
  >
    {count && count > 0 ? count : null}
    {checked ? <Checked /> : <Unchecked />}
  </button>
);

WishlistButton.defaultProps = {
  checkedComponent: IconHeartFilled,
  uncheckedComponent: IconHeartOutlined,
};

WishlistButton.propTypes = {
  className: string,
  checked: bool,
  count: number,
  checkedTitle: string,
  uncheckedTitle: string,
  checkedComponent: elementType,
  uncheckedComponent: elementType,
};

export default WishlistButton;
